// React
import React from 'react';
import { Controller } from 'react-hook-form';
// Material-UI
import TextField from '@mui/material/TextField';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEReferenceListeningArray from './components/PEReferenceListeningArray';

const PEReferenceListening = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Listening Material" instructions="Select the page for the listening material." />
      <Controller
        control={control}
        name="content.material"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Listening Material"
            placeholder="Listening Material"
            id="Listening Material"
            error={!!errors.content?.material}
            helperText={errors.content?.material?.message}
            variant="outlined"
            fullWidth
            required
          />
        )}
      />

      <NumberedHeading number="2" title="Questions" instructions="Using the controls below, add the questions for the referenced reading." />
      <Controller 
        control={control}
        name="content.core"
        render={({ field }) => <PEReferenceListeningArray inputDir={inputDir} {...{control, errors }} />}
      />
    </div>
  )
}

export default PEReferenceListening;